export default __webpack_public_path__ + "static/media/Group 8706_9.6f8dc0cc.png";